import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDollars } from '../../../utils/formatting';

interface Props {
  basePrice: number;
  className?: string;
}

const OriginalsBasePrice: React.FC<Props> = ({ basePrice, className }) => {
  const { t } = useTranslation();
  return (
    <div className={className}>
      {t('deviation.details.originals.basePrice', {
        basePrice: formatDollars(basePrice),
      })}
    </div>
  );
};
OriginalsBasePrice.displayName = 'OriginalsBasePrice';

export default OriginalsBasePrice;
